module.exports = __webpack_public_path__ + "static/media/Hipercard-logo-5.13708756.png";